import { __decorate } from "tslib";
import { Component, Prop, Watch } from 'vue-property-decorator';
import lang from '@blade-sxp/portrait-center/lang/index';
import baseChart from '@blade-sxp/portrait-center/components/fragments/base-chart.vue';
import { barhOption, backUpSeries, backUpAdultSeries, backUpGenderSeries, backUpIdentitySeries } from './barh-config';
import { isEmpty, map } from 'lodash';
import TimeMixin from '@blade-sxp/portrait-center/components/time-mixin.vue';
import { mixins } from 'vue-class-component';
import { PortraitCenterModule } from '@blade-sxp/portrait-center/store/index';
import NoData from '@blade-sxp/portrait-center/pages/components/no-data/index.vue';
import { getFuncVisitorStay } from '@blade-sxp/portrait-center/utils/common-request';
let default_1 = class default_1 extends mixins(TimeMixin) {
    dates;
    zoneType;
    barOption = barhOption();
    barSeries = this.barOption.series;
    dataX = [];
    isLoading = false;
    recordMode = 'GENDER';
    isNoData = true;
    get zoneId() {
        return PortraitCenterModule.zoneId;
    }
    get sourceType() {
        let value = '';
        if (this.zoneType === 'MAP') {
            value = 'VISIT_USER_COUNT';
        }
        else if (this.zoneType === 'VIRTUAL_AREA') {
            value = 'VA_VISIT_USER_COUNT';
        }
        return value;
    }
    onChangeDates() {
        this.fetchData();
    }
    onChangeZoneId() {
        this.fetchData();
    }
    mounted() {
        this.fetchData();
    }
    fetchData() {
        this.isNoData = true;
        if (this.zoneId === 0) {
            return false;
        }
        this.reset();
        this.isLoading = true;
        getFuncVisitorStay({
            dateStart: this.dates[0],
            dateEnd: this.dates[1],
            attributeType: this.recordMode,
            sourceType: this.sourceType,
            businessId: this.zoneId,
            zoneType: this.zoneType,
        })
            .then((res) => {
            if (res) {
                this.setData(res);
            }
        })
            .catch((e) => {
            this.$message.error(e.message || `${this.$t('common.serverError')}`);
        })
            .finally(() => {
            this.isLoading = false;
        });
    }
    setData(data) {
        if (isEmpty(data) && data.length > 0) {
            return;
        }
        this.isNoData = false;
        switch (this.recordMode) {
            case 'AGE':
                this.mapAge(data);
                break;
            case 'GENDER':
                this.mapGender(data);
                break;
            case 'IDENTITY':
                this.mapIdentity(data);
                break;
            default:
                break;
        }
        this.barOption.yAxis.data = map(data, 'name');
    }
    mapAge(data) {
        const elders = [];
        const children = [];
        const adults = [];
        data.forEach((item) => {
            item?.values?.forEach((element) => {
                if (element.time === 'ST_OLD') {
                    elders.push(element.value || 0);
                }
                else if (element.time === 'ST_ADULT') {
                    adults.push(element.value || 0);
                }
                else if (element.time === 'ST_CHILD') {
                    children.push(element.value || 0);
                }
            });
        });
        this.barOption.series[0] = { ...backUpAdultSeries(this), data: adults };
        this.barOption.series[1].name = this.$t('stOld').toString();
        this.barOption.series[1].data = elders;
        this.barOption.series[2] = { ...backUpSeries(this), data: children };
        this.barOption.legend.data = [this.$t('stAdult').toString(), this.$t('stOld').toString(), this.$t('stChild').toString()];
        this.barSeries = this.barOption.series;
        this.barOption = { ...this.barOption };
    }
    mapGender(data) {
        const female = [];
        const male = [];
        data.forEach((item) => {
            item?.values?.forEach((element) => {
                if (element.time === 'FEMALE') {
                    female.push(element.value || 0);
                }
                else if (element.time === 'MALE') {
                    male.push(element.value || 0);
                }
            });
        });
        this.barOption.series[0] = { ...backUpGenderSeries(this), data: male };
        // this.barOption.series[0].data = male;
        this.barOption.series[1].name = this.$t('female').toString();
        this.barOption.series[1].data = female;
        this.barOption.series[2] = undefined;
        this.barOption.legend.data = [this.$t('male').toString(), this.$t('female').toString()];
        this.barSeries = this.barOption.series;
        this.barOption = { ...this.barOption };
    }
    mapIdentity(data) {
        const realName = [];
        const anonymous = [];
        data.forEach((item) => {
            item?.values?.forEach((element) => {
                if (element.time === '1') {
                    realName.push(element.value || 0);
                }
                else if (element.time === '0') {
                    anonymous.push(element.value || 0);
                }
            });
        });
        this.barOption.series[0] = { ...backUpIdentitySeries(this), data: realName };
        // this.barOption.series[0].data = realName;
        this.barOption.series[1].name = this.$t('anonymous').toString();
        this.barOption.series[1].data = anonymous;
        this.barOption.series[2] = undefined;
        this.barOption.legend.data = [this.$t('realName').toString(), this.$t('anonymous').toString()];
        this.barSeries = this.barOption.series;
        this.barOption = { ...this.barOption };
    }
    onModeClick(type) {
        this.recordMode = type;
        this.fetchData();
    }
    reset() {
        this.barOption.legend.data = [];
        this.barOption.yAxis.data = [];
        this.barOption.series[0].data = [];
        this.barOption.series[1].data = [];
        if (this.barOption.series[2]) {
            this.barOption.series[2].data = [];
        }
        this.barSeries = this.barOption.series;
        this.barOption = { ...this.barOption };
    }
};
__decorate([
    Prop()
], default_1.prototype, "dates", void 0);
__decorate([
    Prop()
], default_1.prototype, "zoneType", void 0);
__decorate([
    Watch('dates')
], default_1.prototype, "onChangeDates", null);
__decorate([
    Watch('zoneId')
], default_1.prototype, "onChangeZoneId", null);
default_1 = __decorate([
    Component({
        name: 'gender',
        components: { baseChart, 'no-data': NoData },
        i18n: {
            messages: lang,
        },
    })
], default_1);
export default default_1;
